export default "__VITE_ASSET__YI3U3aSB__"